import { Pipe, PipeTransform } from "@angular/core";
import { Permission } from "../security/permission";
import { PermissionService } from "../services/permission.service";

@Pipe(
    { 
        standalone: false,
        name: 'hasPermission', 
        pure: false 
    }
)
export class HasPermissionPipe implements PipeTransform {
    constructor(private permissionService: PermissionService) { }

    transform(permission: Permission): boolean {
        return this.permissionService.hasPermission(permission);
    }
}

